var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowthgreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 209,
    viewBox: "0 0 428 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 119.07C0 170.5 59.5392 208.713 133.039 209C133.45 209 133.861 209 134.682 209L195.042 201.242V152.111L197.916 86.0288C217.215 122.805 235.693 162.455 243.084 182.854C258.277 225.09 281.682 203.541 298.107 202.104C314.121 200.668 371.607 189.463 390.084 150.962C408.562 112.462 196.685 21.67 202.844 22.2447C209.414 22.8193 295.232 59.5957 380.64 73.6742C466.048 87.7527 414.311 24.5432 391.727 8.4535C377.355 -1.60256 298.517 -0.740612 242.263 1.2706L132.629 3.56914C132.218 3.56914 131.808 3.56914 130.986 3.56914C57.4862 3.85645 0.821218 45.5172 0.821218 97.2341V119.07H0Z",
    fill: "#00FAB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthgreen);
export default __webpack_public_path__ + "static/media/growth(green).c87bac09dbdd42d08d2cd5b8055f509b.svg";
export { ForwardRef as ReactComponent };